//Hook for detecting viewport for responsive display of components https://blog.logrocket.com/developing-responsive-layouts-with-react-hooks/
import {useState, useEffect} from 'react';


const useViewport = () => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  // Return the width so we can use it in our components
  return { width };
}

export default useViewport;